export default __webpack_public_path__ + "static/media/information--exit-ahead--g2.d7e0a668.png";